const React = require('react');
const AjaxFunctions = require('./../ajaxFunctions');
const Link = require('react-router-dom').Link;

exports.UserSearch = class UserSearch extends React.Component{
   constructor(props) {
      super(props);
      this.state={
         searchString: '',
         isLoading: false,
         results: null,
      }
   }

   doUserSearch(){
      if (this.state.searchString.trim().length === 0) {
         this.setState({results: null});
      } else {
         this.setState({isLoading: true}, () => {
            AjaxFunctions.searchUsers(this.state.searchString.trim()).then((data) => {
               this.setState({isLoading: false, results: data.userArray});
            });
         });
      }
   }

   render() {
      let resultsList = () => {
         if(this.state.results) {
            let users = this.state.results.filter(user => this.props.usersToExclude ? !this.props.usersToExclude.includes(user.idUser) : true)
               .map((user) => {
               let adminButton = () => {
                  return(
                     <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.userBtnFunction(user.id)}>
                        {this.props.userBtnText}
                     </button>
                  )
               };
               return(
                  <li className="list-group-item d-flex justify-content-between align-items-center" key={user.id}>
                     <div className="user d-flex align-items-center">
                        <div className="avatar" />
                        <Link to={`/users/profile?idUser=${user.id}`}>
                        <div className="user-name">{user.firstName + ' ' + user.lastName }</div>
                        </Link>
                     </div>
                     {adminButton()}
                  </li>
               )
            });
            return(

               <div className={'user-search-results expanded card'}>
                  <div className="leading">{users.length} Results</div>
                  <ul className="list-group">
                     {users}
                  </ul>
               </div>
            )
         }
         return <div className={'user-search-results'} />
      };

      let searchIcon = 'fa fa-search';
      if(this.state.isLoading) searchIcon = 'fa fa-spinner fa-spin';


      return (
         <form className="form-group" onSubmit={(e) => {this.doUserSearch(); e.preventDefault();}}>
            <input id='userSearchText' className="form-control" type="search" placeholder="Search for a User" aria-label="Search"
                   onChange={(e) => this.setState({'searchString': e.target.value})}
            />
            <button className="search-btn float-right">
               <i className={searchIcon} aria-hidden="true" />
            </button>
            {resultsList()}
         </form>
      );
   }
};